module.exports = __webpack_public_path__ + "img/pe.981d6b70.svg";